<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        </div>
    </nav>


    <div class="animated fadeIn container-fluid">
        <h4>Especie Vegetal</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabeceraEspecieVegetal = !isCollapsedCabeceraEspecieVegetal" [attr.aria-expanded]="!isCollapsedCabeceraEspecieVegetal" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Especie Vegetal
                                    <i *ngIf="isCollapsedCabeceraEspecieVegetal" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabeceraEspecieVegetal" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabeceraEspecieVegetal" [ngbCollapse]="isCollapsedCabeceraEspecieVegetal">

                                    <div class="row">

                                        <div class="form-group col-md-4">

                                            <label class="col-form-label" for="inpDescripcion">Nombre</label>
                                            <input readonly formControlName="IdNombreCientificoDescripcion" name="IdNombreCientificoDescripcion" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('IdNombreCientificoDescripcion')" type="text" value="">

                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpDescripcion">Código Eppo</label>
                                            <input readonly formControlName="CodigoEppo" name="CodigoEppo" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('CodigoEppo')" type="text" value="">
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosEspecieVegetal = !isCollapsedDatosEspecieVegetal" [attr.aria-expanded]="!isCollapsedDatosEspecieVegetal" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Grupos, Formas y/o Subformas asociadas
                                    <i *ngIf="isCollapsedDatosEspecieVegetal" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosEspecieVegetal" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosEspecieVegetal" [ngbCollapse]="isCollapsedDatosEspecieVegetal">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Grupo</label>
                                            <ng-select [items]="listGrupo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdGrupo"
                                                       loadingText="Cargando..."
                                                       [loading]="!listGrupo"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdGrupo')"
                                                       (change)="onSelectGrupo()" style="pointer-events: none;">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupo','required')">
                                                Grupo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Forma</label>
                                            <ng-select [items]="listForma"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdForma"
                                                       loadingText="Cargando..."
                                                       [loading]="(!listForma && (form.value.IdGrupo !== null))"                                                      
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdForma')"
                                                       (change)="onSelectForma()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdForma','required')">
                                                Forma es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intEstado">Subforma</label>
                                            <ng-select [items]="listSubForma"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdSubForma"
                                                       loadingText="Cargando..."
                                                       [loading]="(!listSubForma && (form.value.IdForma !== null))"                                                      
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdSubForma')">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpDescripcion">Nombre Común</label>
                                            <input readonly formControlName="NombreComun" maxlength="100" name="NombreComun" class="form-control"
                                                   inputStyleClass="form-control" type="text" value="">
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpDescripcion">Habilitado Importación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoImportacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpDescripcion">Habilitado Exportación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoExportacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpDescripcion">Habilitado China</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoChina" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpDescripcion">Activa</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

